<!-- {{blog | json}} -->
<!-- <div *ngIf="feedsList"> -->

  <!-- <div class="wrap-list-card card-bg-white" *ngFor="let feed of feedsList">
 {{feed | json}}
    <img class="card-img" [src]="feed.media.length > 0 ? feed.media[0].url : 'assets/images/fab.jpg'"
      alt="Feed Image" />
    <div class="card-right-wrap">
      <span class="time">{{feed?.updatedAt | formatDate}}</span>
      <h4 class="sec-title">{{feed?.title}}</h4>
      <p>{{feed?.content}}</p>
    </div>
  </div>
</div> -->
<!-- {{blog.post_permalink}} -->
<a class="wrap-list-card card-bg-white" *ngIf="blog" [href]="blog.absolute_url" target="_blank">
  <img class="card-img" [src]="blog.banner_url" />
  <div class="card-right-wrap">
      <span class="time">{{blog.createdAt | formatDate}}</span>
      <h4 class="sec-title">{{blog.title}}</h4>
  </div>
</a>

